export const PKG_NAME = "@hpcc-js/dgrid-shim";
export const PKG_VERSION = "3.5.6";
export const BUILD_VERSION = "3.34.1";
